import { PanelTable } from '~/components/ui';
import { formatLocalTime } from '~/lib/datetime';
import { queryErrorMessage } from '~/modules/query';
import { useGetAgreementHistoryQuery } from '~/modules/query/mlsAgreements';

import type { HistoryRow } from '~/components/pages/mls-agreements/types';

const text = (value: unknown): string =>
  value === undefined || value === null ? '—' : String(value);

const clip = (value: unknown) => (
  <span className="block max-w-40 truncate" title={text(value)}>
    {text(value)}
  </span>
);

// Field-level change history for any entity (mls, customer, membership, credential_set).
export const HistoryPanel = ({
  entityType,
  entityId,
}: {
  entityType: string;
  entityId: string;
}) => {
  const { data, isLoading, error, refetch } = useGetAgreementHistoryQuery({ entityType, entityId });

  return (
    <PanelTable<HistoryRow>
      ariaLabel="Change history"
      testId="mls-agreements-history"
      loading={isLoading}
      error={
        error
          ? { what: 'the change history', message: queryErrorMessage(error), onRetry: refetch }
          : undefined
      }
      emptyMessage="No changes recorded yet."
      emptyDescription="Edits to this record are listed here once someone saves one."
      data={(data ?? []) as HistoryRow[]}
      getRowId={(_, i) => i}
      columns={[
        { header: 'Field', render: (e) => text(e.field) },
        { header: 'Old', render: (e) => clip(e.oldValue) },
        { header: 'New', render: (e) => clip(e.newValue) },
        { header: 'By', render: (e) => text(e.actor) },
        { header: 'When', render: (e) => formatLocalTime(e.at) },
      ]}
    />
  );
};

export default HistoryPanel;
